<script lang="ts">
  import type { Token } from '$lib/interfaces';
  import TokenMediaViewer from '$lib/components/TokenMediaViewer/Viewer.svelte';
  import { shortAddress } from '$lib/format';

  export let token: Token;
  export let hoverEffects = false;

  $: tokenLink = `/tokens/${token.coinType}/${token.chainId}/${token.contractAddress}/${token.id}`;
</script>

<div>
  <a href={tokenLink}>
    <TokenMediaViewer
      autoplay
      square
      rounded
      shadow
      scale={hoverEffects}
      metadata={token.metadata}
    />
  </a>
  <section>
    <div>
      <h2 class="mt-4">
        <a href={tokenLink} class="heading-3 text-primary">{token.metadata.name}</a>
      </h2>

      <h3 class="bold-bold text-grey">
        {shortAddress(token.contractAddress)}
      </h3>
    </div>
  </section>
</div>
